export default {
    screen: 'screen',
    podZoom: 'Pod - Zoom',
    podInfrared: 'Pod - Infrared',
    podWideAngle: 'Pod - Wide Angle',
    forwardLookingFPV: 'Forward looking FPV',
    downLookingLens: 'Down looking lens',
    rearViewLens: 'Rear view lens',
}